var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeef({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 42,
    viewBox: "0 0 52 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4584 1C45.136 1.4336 44.04 2.30081 42.2347 2.30081C40.4295 2.30081 40.3005 4.25203 40.4617 5.22764C39.8707 4.25203 38.0117 2.30081 35.3038 2.30081C35.3038 3.60163 35.8411 5.76965 36.1098 6.69106L35.3038 7.82927C33.101 7.01626 27.2447 5.87805 21.4421 7.82927C14.1889 10.2683 12.577 7.82927 9.03103 7.82927C7.55357 7.82927 6.52381 8.19623 5.89511 9.13008M43.2018 6.69106C45.942 6.69106 46.2643 8.96748 48.6821 10.2683C51.0998 11.5691 50.9386 11.4065 50.1327 14.0081C49.3268 16.6098 46.2643 15.6341 44.0078 15.4715C41.7512 15.3089 39.3335 16.935 39.4946 19.8618C39.6558 22.7886 36.9157 30.2683 36.1098 34.6585C35.465 38.1707 36.7008 40.3496 37.3993 41H32.4026C32.4026 40.3496 32.4026 38.6911 32.4026 37.2602C32.4026 35.8293 31.7579 32.0027 31.4355 30.2683C29.2864 30.7019 24.5046 31.3089 22.5704 30.2683C20.1527 28.9675 16.4455 28.4797 13.5442 28.4797C13.383 30.7561 11.7712 31.4065 9.83699 34.6585C8.28963 37.2602 9.72953 39.9702 10.6429 41H5.485C5.485 39.4824 5.485 35.7317 5.485 32.8699C5.485 29.2927 6.4521 23.9268 5.485 16.935C4.92085 12.8563 5.01489 10.4376 5.89511 9.13008M5.89511 9.13008C4.68387 9.88889 2.19692 12.5122 1.93903 16.935C1.61666 22.4634 0.00483296 23.2764 0.97193 25.065C1.74561 26.4959 2.36884 26.9621 2.58375 27.0163",
    stroke: "#03422F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3831 8.80523V20.1873M27.406 6.69141V30.106M34.6592 7.50441C34.6592 9.56404 35.6585 14.3662 39.6559 17.0979M39.0111 20.1873H13.3831M13.3831 20.1873V28.1548H6.29102M32.2415 30.106H36.271",
    stroke: "#03422F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeef);
export default __webpack_public_path__ + "static/media/beef.90b006b1128c2632b9645963b942cd9c.svg";
export { ForwardRef as ReactComponent };